/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	CompanyUserDTO,
	CompanyUserDTOFromJSON,
	CompanyUserDTOFromJSONTyped,
	CompanyUserDTOToJSON,
} from "./CompanyUserDTO";

/**
 *
 * @export
 * @interface CompanyUserDTOPagedResponse
 */
export interface CompanyUserDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof CompanyUserDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyUserDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof CompanyUserDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<CompanyUserDTO>}
	 * @memberof CompanyUserDTOPagedResponse
	 */
	data?: Array<CompanyUserDTO> | null;
}

export function CompanyUserDTOPagedResponseFromJSON(
	json: any
): CompanyUserDTOPagedResponse {
	return CompanyUserDTOPagedResponseFromJSONTyped(json, false);
}

export function CompanyUserDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyUserDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(CompanyUserDTOFromJSON),
	};
}

export function CompanyUserDTOPagedResponseToJSON(
	value?: CompanyUserDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(CompanyUserDTOToJSON),
	};
}
